import jQuery from 'jquery'
import DataTable from 'datatables.net'
import _ from 'lodash'

// jQuery plugins (loaded as side-effect imports after this module) expect
// the jQuery globals on window, so this module must be imported first.
window.jQuery = jQuery
window.$ = window.jQuery // allows use of jQuery
window.DataTable = DataTable
// webpack used to inject lodash as a global (ProvidePlugin); components and
// store modules call _.trim/_.isEmpty etc. without importing it.
window._ = _